// angular
// 	.module("HeroPRO")
// 	.directive("hpEmailInput", EmailInput);

export default function EmailInput() {
    return {
        require: '^form',
        restrict: 'E',
        //		controller: "EmailController",
        //		controllerAs: "email",
        //		bindToController: true,
        templateUrl: 'app/common/controls/email/emailTemplate.html',
        scope: {
            value: '@?',
            emailId: '@?',
            placeholderText: '@?',
            isRequired: '@?',
            isLabelVisible: '@',
            emailLabel: '@?',
            isFormSubmitted: '@?',
            isVisible: '@?',
            onBlur: '&?',
            onClick: '&?',
        },
        transclude: true,
        link,
    };

    function link(scope, element, attr, ctrl) {
        scope.$watch(scope.isFormSubmitted, () => {
            if (scope.value === '' && scope.isVisible) {
                ctrl.emailForm.emailName.$setValidity('required', false);
                scope.errorMessage = 'Required';
            } else if (scope.isVisible) {
                ctrl.emailForm.emailName.$setValidity('required', true);
                scope.errorMessage = '';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/controls/email/emailDirective.js